import { css } from 'styled-components';
import { TypographyColors } from '../../core/theme';

export const DarkTextColor = css`
  && {
    color: ${TypographyColors.darkText};
  }
`;

export const WhiteTextColor = css`
  && {
    color: ${TypographyColors.whiteText};
  }
`;
